export interface AbortError extends Error {
  readonly name: 'AbortError';
  readonly message: string;
}
export const isAbortError = (error: unknown): error is AbortError => {
  return (
    error !== null &&
    typeof error === 'object' &&
    'name' in error &&
    typeof error.name === 'string' &&
    error.name === 'AbortError'
  );
};
